import React, { useState, useRef, useEffect, } from 'react';
import { useParams } from "react-router-dom";
import uuid from 'react-uuid'
import Loader from 'react-loader-spinner';
import { withFirebase } from '../firebase';


const TeamListForm = (props) => {

    const { onClose, showModal, playerUidList } = props;
    const [player, setPlayer] = useState(props.player);
    const inputFocusRef = useRef();

    useEffect(() => {
        inputFocusRef.current.focus();
        setPlayer(props.player)
    }, [props.player])

    const { tournament_uid, team_uid } = useParams(); // tournament and team uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const [saving, setSaving] = useState(false)
    const [dni, setDni] = useState(player.dni || '');
    const [name, setName] = useState(player.name || '');
    const [number, setNumber] = useState(player.number);
    const [position, setPosition] = useState(player.position);

    const disableNumber = position === "Director Técnico";

    const onSubmit = (e) => {
        e.preventDefault();

        const invalid = dni === '' || dni.length < 5 || name === '';

        if (!invalid && !saving) {
            setSaving(true);

            try {
                const batch = props.firebase.batch();

                let playerUid = player.uid
                if (!player.uid) {
                    playerUid = uuid()
                    playerUidList.push(playerUid)
                }

                const newPlayer = {
                    userUid: userId,
                    tournamentUid: tournament_uid,
                    teamUid: team_uid,
                    createdAt: props.firebase.timestamp(),
                    dni: dni,
                    name: name,
                    number: number || 0,
                    position: position || ''
                }
                batch.set(props.firebase.playerDoc(userId, tournament_uid, playerUid), newPlayer);
                if (!player.uid) {
                    batch.update(props.firebase.teamDoc(userId, tournament_uid, team_uid), { players: JSON.stringify(playerUidList) });
                }
                batch.commit().then(() => {
                    setSaving(false);
                    onClose();
                }).catch(error => {
                    setSaving(false);
                    console.log("Error: ", error);
                    showModal("Error", "Ocurrió un error al guardar los datos del jugador. Compruebe los datos e intentelo de nuevo.")
                    onClose();
                });

            } catch (error) {
                setSaving(false);
                console.log("Error: ", error);
                onClose();
                showModal("Error", "Ocurrió un error al guardar los datos del jugador. Compruebe los datos e intentelo de nuevo.")
            }
        }
    }

    const invalid = dni === '' || dni.length < 5 || name === '';
    return (

        <div className="">
            <span className="font-weight-bolder ml-2">Añadir nuevo Jugador</span>

            <form onSubmit={onSubmit}>

                <div className="row m-0">
                    <div className="col row pl-0 pr-0 m-0">

                        <div className="col-auto p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="dni">Dni: *</label>
                            <input ref={inputFocusRef} className="form-control form-control-sm" id="dni" style={{ width: 85 }}
                                value={dni || ''} type="text" autoComplete="off"
                                onChange={(e) => setDni(e.target.value)} />
                        </div>

                        <div className="col p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="name">Nombre del Jugador: *</label>
                            <input className="form-control form-control-sm autofocus" value={name || ''}
                                type="text" onChange={(e) => setName(e.target.value)} id="name" autoComplete="off" />
                        </div>

                        <div className="w-100" />

                        <div className="col p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="teamB">Posición:</label>
                            <select value={position} onChange={(e) => setPosition(e.target.value)} className="form-control form-control-sm text-dark" id="teamB">
                                <option className="text-black-50 font-italic" value="">Seleccionar...</option>
                                <option value="Director Técnico">Director Técnico</option>
                                <option value="Arquero">Arquero</option>
                                <option value="Defensa">Defensa</option>
                                <option value="Medio">Medio</option>
                                <option value="Ataque">Ataque</option>
                            </select>
                        </div>

                        <div className="col-auto p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="number">Número:</label>
                            <input disabled={disableNumber} className="form-control form-control-sm" id="number" style={{ width: 60 }}
                                value={number || ''} type="number" min="1" max="100" autoComplete="off"
                                onChange={(e) => setNumber(e.target.value !== '' ? parseInt(e.target.value, 10) : null)} />
                        </div>

                    </div>

                    {(!saving) ?
                        <div className="col-12 d-flex flex-row-reverse p-0 mt-2">
                            <button disabled={invalid} type="submit" className="col-auto btn btn-sm btn-success m-1">Guardar</button>
                            <button onClick={onClose} className="col-auto btn btn-sm btn-secondary m-1">Cancelar</button>
                        </div>
                        :
                        <div className="col-12 d-flex flex-row-reverse p-0 mt-2">
                            <Loader className=""
                                type="ThreeDots"
                                color="#263238"
                                height={39}
                                width={50}
                                timeout={0} />
                        </div>
                    }
                </div>

            </form>
        </div>
    )

}

export default withFirebase(TeamListForm);
